import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import TelephoneInputField from "../../components/forms/TelephoneInputField";
import FormError from "../../components/forms/FormError";
import normalizeTelephone from "../../lib/TelephoneNormalizer";

class ContactDetailsForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>Please note that changing the email address for a customer will affect the login credentials.</p>
          <FormFieldsTable>
            <Field
              label="Name"
              name="name"
              component={TextInputField}
              />
            <Field
              label="Email"
              name="email"
              component={TextInputField}
              />
            <Field
              label="Phone"
              name="phone"
              normalize={normalizeTelephone}
              component={TelephoneInputField}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "ContactDetailsForm"
})(ContactDetailsForm);

export default ReduxForm;